import React from 'react';
import DescriptionIcon from '@mui/icons-material/TextSnippetOutlined';
import { Container, RightContainer, Title, DropdownContainer } from './styled';
import  DropdownProduto  from './DropdownProduto';
import {  useSelector } from 'react-redux';


const Produto = () => {
  // const thisCard = useSelector((state) => state.card);

  return (
  <Container >    
    <DescriptionIcon fontSize='small' />
      <RightContainer>
        <Title>Produto</Title>
        <DropdownContainer>
					<DropdownProduto />
				</DropdownContainer>
      </RightContainer>
  </Container>
  )
};

export default Produto;
